import React, { useState } from 'react';

import {
  StyleWrapper,
  StyledLabel,
  StyledSelect,
  StyledDropDownIcon,
} from './DropdownButton.styled';

const DropdownButton = (props) => {
  const { label, active } = props;
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <StyleWrapper>
        <StyledLabel active={active} onClick={handleOpen}>{label}</StyledLabel>
        <StyledSelect
          IconComponent={StyledDropDownIcon}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
        >
          {props.children}
        </StyledSelect>
    </StyleWrapper>
  );
};

export default DropdownButton;
